import React from "react";
import { Link } from "react-router-dom";
import { corePolicyLinks, policyPages } from "../Datas/policyData";
import { siteConfig } from "../Datas/productData";
import "../css/privacy.scss";
import "../css/policy.scss";

const policyGroups = [
  {
    title: "Shopping & orders",
    description: "The rules and practical steps that apply before, during and after a purchase.",
    links: [
      corePolicyLinks.terms,
      { slug: "orders" },
      { slug: "payments" },
      corePolicyLinks.shipping,
      corePolicyLinks.returns,
      { slug: "warranty-claims" },
      { slug: "promotions" },
      { slug: "product-safety" },
    ],
  },
  {
    title: "Privacy, trust & access",
    description: "How information, site security and inclusive access are handled.",
    links: [
      corePolicyLinks.privacy,
      corePolicyLinks.cookies,
      { slug: "privacy-choices" },
      { slug: "children" },
      { slug: "security" },
      { slug: "accessibility" },
    ],
  },
  {
    title: "Store standards",
    description: "Identity, rights, conduct, responsible supply and complaint handling.",
    links: [
      { slug: "legal-notice" },
      { slug: "intellectual-property" },
      { slug: "acceptable-use" },
      { slug: "reviews-content" },
      { slug: "responsible-sourcing" },
      { slug: "complaints" },
    ],
  },
];

const resolveLink = (item) => {
  if (!item.slug) return item;
  const policy = policyPages.find(({ slug }) => slug === item.slug);
  return policy ? { label: policy.title, to: `/policies/${policy.slug}`, summary: policy.summary } : null;
};

function PolicyCenter() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <main className="privacy policy-hub">
      <div className="privacy__shell">
        <nav className="privacy__breadcrumb" aria-label="Breadcrumb">
          <Link to="/" onClick={toTop}>Home</Link>
          <span aria-hidden="true">/</span>
          <span aria-current="page">Legal &amp; policies</span>
        </nav>

        <header className="privacy__header policy-hub__header">
          <p className="privacy__kicker">Customer information</p>
          <h1>Legal &amp; policy centre</h1>
          <p className="privacy__updated">Current as of 23 October 2026</p>
          <p className="privacy__lede">
            One place for the policies that explain shopping, privacy, customer rights and responsible use of the
            {" "}{siteConfig.brandName} storefront.
          </p>
        </header>

        <aside className="privacy__demo policy-hub__notice" aria-label="Policy centre notice">
          <span aria-hidden="true">i</span>
          <p>
            <strong>Original policy wording.</strong> These pages are written for {siteConfig.brandName} and do not
            reproduce another retailer’s legal text, imagery, identity or protected brand material. Mandatory rights
            under applicable law are not excluded by a store policy.
          </p>
        </aside>

        <div className="policy-hub__groups">
          {policyGroups.map((group, groupIndex) => (
            <section className="policy-hub__group" key={group.title} aria-labelledby={`policy-group-${groupIndex}`}>
              <header>
                <p>{String(groupIndex + 1).padStart(2, "0")}</p>
                <div>
                  <h2 id={`policy-group-${groupIndex}`}>{group.title}</h2>
                  <span>{group.description}</span>
                </div>
              </header>
              <div className="policy-hub__grid">
                {group.links.map(resolveLink).filter(Boolean).map((link) => (
                  <Link className="policy-hub__card" to={link.to} onClick={toTop} key={link.to}>
                    <h3>{link.label}</h3>
                    {link.summary && <p>{link.summary}</p>}
                    <span aria-hidden="true">Read policy →</span>
                  </Link>
                ))}
              </div>
            </section>
          ))}
        </div>

        <section className="policy-hub__contact" aria-labelledby="policy-contact-title">
          <div>
            <p>Questions or notices</p>
            <h2 id="policy-contact-title">Need help finding the right policy?</h2>
            <span>Tell us what your question relates to and include an order number when applicable.</span>
          </div>
          <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}<span aria-hidden="true">→</span></a>
        </section>
      </div>
    </main>
  );
}

export default PolicyCenter;
